export default __webpack_public_path__ + "static/media/7_1.a02fba9f.png";